import React from 'react';
import { connect } from 'react-redux';
import PropTypes, { any } from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { EventProfileTabIdentifiers } from '../../../utils/constants';
import { eventStateTypeIds } from '../../../utils/eventConstants';

const RegistrationCta = (props) => {
    // redux mapping
    const { auth, event } = props;
    // component props
    const { isCurrentMemberAdmin, handleRegClick, handleTabClick } = props;
    const inProgressOrCompletedButtonIsShown = (event.eventStateId === eventStateTypeIds.IN_PROGRESS || event.eventStateId === eventStateTypeIds.COMPLETED);

    return (
        <div className="register mt16">
            {((event.eventState.value === 'pre_registration' || event.eventState.value === 'registration_closed') && event.registered !== true) && (
                <button
                    type="button"
                    className="btn btn-primary btn-lg btn-block text-uppercase disabled"
                    disabled={true}
                >
                    {event.eventState.value === 'pre_registration' ? `Registration begins on ${event.eventSchedule.registrationStartShort}` : 'Registration is closed'}
                </button>
            )}
            {((event.eventState.registrationState.value === 'open_registration' && event.eventState.value !== 'in_progress' && event.eventState.value !== 'completed') || event.registered === true) && (
                <button
                    type="button"
                    className={`btn btn-primary btn-lg btn-block text-uppercase ${event.published ? '' : 'disabled'}  ${inProgressOrCompletedButtonIsShown ? 'disabled' : ''}`}
                    onClick={handleRegClick}
                    disabled={inProgressOrCompletedButtonIsShown}
                >
                    {auth.user ? event.registered ? 'Edit Registration' : 'Register' : 'Register'}
                </button>
            )}
            {(event.eventState.value === 'in_progress' || event.eventState.value === 'completed') && (
                <>
                    <button
                        type="button"
                        className="btn btn-primary btn-lg btn-block text-uppercase"
                        onClick={() => handleTabClick(null, EventProfileTabIdentifiers.DRAWS)}
                    >
                        {event.eventState.value === 'in_progress' ? 'In Progress' : 'Completed'} - View {event.eventType?.value === 'flex_league' ? 'Matchups' : 'Draws'}
                    </button>
                    {event.eventState.registrationState.value === 'open_registration' && (
                        <p className="text-small mt16 text-center">
                            You can still <span className={`text-teal cursor-pointer`} onClick={handleRegClick}>{auth.user ? event.registered ? 'edit' : 'register' : 'register'}</span><span>{auth.user ? event.registered ? ' your registration' : '' : ''}</span> for this event.
                        </p>
                    )}
                </>
            )}

            {(event.eventState.value !== 'in_progress' && event.eventState.value !== 'completed') && event.registered !== true && (
                <p className="text-small text-center">{event.eventSchedule.registrationEndString}</p>
            )}
            {isCurrentMemberAdmin && event.eventState.value !== 'completed' && event.eventState.registrationState.value === 'registration_closed' && event.registered !== true && (
                <p className="text-small text-center">
                    Need to add a player after registration has closed? <Link to={`/events/${event.id}/edit?step=1/`}>Click here</Link> to reopen registration
                </p>
            )}
        </div>
    );
};

function mapStateToProps({ auth, events }) {
    const { data: event } = events.currentEvent;
    return { auth, event };
}

RegistrationCta.propTypes = {
    isCurrentMemberAdmin: PropTypes.bool,
    handleRegClick: PropTypes.func,
    handleTabClick: PropTypes.func,
    event: PropTypes.objectOf(any),
};
RegistrationCta.defaultProps = {
    isCurrentMemberAdmin: false,
    handleRegClick: () => { },
    handleTabClick: () => { },
    event: null,
};
export default withRouter(connect(mapStateToProps)(RegistrationCta));
